import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "./Personal.scss";
import "react-international-phone/style.css";
import "react-datepicker/dist/react-datepicker.css";
import SoftButton from "StyleFeatures/SoftButton";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import choosefile from "assets/images/uploadfile.png";
import personalInformationService from "Pages/AdministratorDashboard/APIServices/PersonalInformationService";
import Footer from "Common/Footer";
import { Card, Spin, Alert } from "antd";

function Personal({ onNext, initialData = {} }) {
  const {
    formData,
    formDataError,
    setFormDataError,
    handleChange,
    handleImageChange,
    validatePersonalValidation,
    emailExists,
    initializeWithInitialData,
    employeeData,
    isLoading,
    error,
    verifyEmail,
    isEmailVerified,
  } = personalInformationService();

  useEffect(() => {
    if (initialData && Object.keys(initialData).length > 0) {
      initializeWithInitialData(initialData);
      if (initialData.image && typeof initialData.image === "string") {
        setSelectedImage(initialData.image);
      }
    }
  }, [initialData]);

  const [selectedImage, setSelectedImage] = useState(null);

  const handleNext = async () => {
    setFormDataError({ ...formDataError, workEmailError: "" });

    const isValid = validatePersonalValidation(formData, setFormDataError);
    if (!isValid) {
      toast.error("Fields Required");
      return;
    }

    if (!isEmailVerified) {
      toast.error("Please verify the email first");
      return;
    }

    if (!employeeData || !employeeData.employeeName) {
      toast.error("Employee data is not loaded yet. Please wait.");
      return;
    }

    const employeeName = employeeData.employeeName;

    const dataWithDeptEmpName = {
      ...formData,
      departmentId: employeeData?.departmentId || 0,
      fullName: employeeName,
    };

    onNext(dataWithDeptEmpName);
  };

  const handleImageClick = () => {
    document.getElementById("fileInput").click();
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setSelectedImage(URL.createObjectURL(selectedFile));
    }
    handleImageChange(event);
  };

  return (
    <div className="body flex-grow-1 px-3">
      <Card title="Personal Info" className="card-professional">
        {/* Loading state */}
        {isLoading && (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <Spin size="large" />
            <p style={{ marginTop: "10px" }}>Loading employee data...</p>
          </div>
        )}

        {/* Error state */}
        {error && !isLoading && (
          <Alert
            message="Error"
            description={error}
            type="error"
            showIcon
            style={{ marginBottom: "20px" }}
          />
        )}

        {/* Form content - only show when not loading and no error */}
        {!isLoading && !error && (
          <>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleNext();
              }}
              encType="multipart/form-data"
            >
              <ToastContainer />
              <div className="row">
                <label className="mb-3" style={{ textAlign: "left" }}>
                  <i className="fa fa-info-circle" aria-hidden="true"></i>&nbsp;BASIC INFORMATION
                </label>
                <input
                  type="hidden"
                  value={formData?.personalId || 0}
                  className="form-control"
                  onChange={handleChange}
                />
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <div className="mb-3">
                      <div style={{ position: "relative", display: "inline-block" }}>
                        <label
                          htmlFor="exampleInput"
                          className="form-label"
                          style={{ fontSize: "medium" }}
                        >
                          Upload File *
                        </label>
                        <br></br>
                        {selectedImage ||
                        (typeof formData?.image === "string" && formData?.image) ? (
                          <img
                            src={selectedImage || formData?.image}
                            alt="Selected Avatar"
                            style={{
                              height: "100px",
                              width: "100px",
                              cursor: "pointer",
                              borderRadius: "50%",
                            }}
                          />
                        ) : (
                          <img
                            src={choosefile}
                            alt="Avatar"
                            style={{
                              height: "100px",
                              width: "100px",
                              cursor: "pointer",
                              border: `2px dashed ${formDataError?.imageError ? "red" : "black"}`,
                            }}
                            onClick={handleImageClick}
                          />
                        )}
                        <input
                          type="file"
                          id="fileInput"
                          accept="image/*"
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            opacity: 0,
                            cursor: "pointer",
                          }}
                          onChange={handleFileChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-5 mb-3">
                    <label className="form-label" style={{ fontSize: "medium" }}>
                      Work Email *
                    </label>

                    <div style={{ display: "flex", gap: "10px" }}>
                      <input
                        name="workEmail"
                        value={formData?.workEmail || ""}
                        onChange={handleChange}
                        type="text"
                        className={`form-control ${
                          formDataError?.workEmailError || emailExists ? "is-invalid" : ""
                        }`}
                        placeholder="Enter work email here"
                      />

                      <SoftButton
                        className="btn-back"
                        size="small"
                        type="button"
                        onClick={verifyEmail}
                      >
                        Verify
                      </SoftButton>
                    </div>

                    {(formDataError?.workEmailError || emailExists) && (
                      <div style={{ color: "red", fontSize: "13px", marginTop: "5px" }}>
                        {formDataError?.workEmailError ||
                          "Work email already exists. Please enter another email."}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </form>
            <div className="col-md-9 mb-3">
              <SoftButton
                variant="outlined"
                style={{ float: "inline-end" }}
                className="btn-primary"
                size="small"
                onClick={handleNext}
                disabled={!employeeData || !employeeData.employeeName || !isEmailVerified}
                type="button"
              >
                Next
              </SoftButton>
            </div>
          </>
        )}
      </Card>
      <Footer />
    </div>
  );
}

Personal.propTypes = {
  onNext: PropTypes.func.isRequired,
  initialData: PropTypes.object,
};

Personal.defaultProps = {
  initialData: {},
};

export default Personal;
